import { Fragment } from 'react';

import { Trans } from 'react-i18next';

import { Icons } from 'app/constants/icons';
import { COSMOS_KIT_WALLETS_INFO } from 'app/constants/wallets';
import { useCosmosKitManager } from 'app/hooks/useAuthentication';
import { useIsMobile } from 'app/hooks/useIsMobile';

import { Or } from '../Or';
import { WalletsModal } from './WalletsModal';
import { Button } from 'app/shared/buttons/Button';

export const CosmosKitWallets = () => {
  const manager = useCosmosKitManager();
  const isMobile = useIsMobile();

  const providers = Object.fromEntries(
    Object.entries(COSMOS_KIT_WALLETS_INFO).filter(
      ([provider, {isMobile: isMobileProvider, isDisabled, isInstalled}]) => {
        const chainWallet = manager.mainWallets.find(
          e => e.walletName === provider,
        );

        if (isDisabled) {
          return false;
        }

        if (isMobile && isMobileProvider) {
          return true;
        }

        if (!isMobile && chainWallet && isInstalled?.(chainWallet)) {
          return true;
        }

        return false;
      },
    ),
  );

  return (
    <>
      <Or />

      <Button
        // {...buildEvent('button', 'connect-with-wallet')}
        data-modal-toggle="connect-wallets"
        className="group w-full gap-5 font-semibold mobile:gap-3.75"
        size="xl"
        variant="secondary-gray-contained">
        <span className="text-base">
          <Trans i18nKey="connect.connectWithDigitalWallet" />
        </span>

        <div className="flex items-center gap-[7px]">
          <div className="flex items-center gap-2.5 mobile:gap-[7px]">
            {Object.entries(providers)
              .slice(0, 3)
              .map(([provider, {Icon}]) => {
                return (
                  <Fragment key={provider}>
                    {Icon && <Icon className="h-5 w-5" />}
                  </Fragment>
                );
              })}
          </div>

          {Object.entries(providers).length > 3 && (
            <span className="text-sm font-normal leading-normal">
              +{Object.entries(providers).length - 3}
            </span>
          )}
        </div>

        <div className="w-2">
          <Icons.chevronRight
            className="-ml-[5px] transition-all group-hover:translate-x-0.5"
            size={18}
            strokeWidth={3}
          />
        </div>
      </Button>

      <WalletsModal />
    </>
  );
};
